import React from 'react';
import '../styles/chestInfoModal.css';
import i18n from '../../../i18n';

/**
 * Item image on a rarity-coloured glowing podium with an "owned" counter below.
 * Shared by the chest and key popups so both read the same way.
 * `quantity == null` hides the counter (e.g. a key the player doesn't have).
 */
export default function LootboxHero({ imageUrl, alt, color, quantity }) {
  const owned = quantity > 0;
  return (
    <div className="lb-hero" style={{ '--rarity-color': color }}>
      <div className={`lb-hero-stage${owned ? '' : ' lb-hero-stage--empty'}`}>
        <div className="lb-hero-glow" />
        {imageUrl
          ? <img className="lb-hero-img" src={imageUrl} alt={alt} />
          : <span className="lb-hero-emoji">🗝</span>}
      </div>
      {quantity != null && (
        <div className={`lb-hero-qty${owned ? '' : ' lb-hero-qty--zero'}`}>
          <span className="lb-hero-qty-x">×</span>
          <span className="lb-hero-qty-num">{quantity}</span>
          <span className="lb-hero-qty-label">{i18n.t('lootbox.owned', 'owned')}</span>
        </div>
      )}
    </div>
  );
}
